import * as React from "react";

export const HealthDashboard = () => {
    return <div className="health">
        Not yet implemented
    </div>
}

